module.exports = __webpack_public_path__ + "img/HE7101-163.be65df03.jpg";